import React, { useState } from 'react'
import { Row, Col, Button, Modal, Form } from 'react-bootstrap';
import { getItem, setItem } from '../../config/localStorage';

function HobbiesModal(props) {

    const getHobbiesData = getItem('hobbiesData') ? JSON.parse(getItem('hobbiesData')) : '';

    const [hobbies, setHobbies] = useState(getHobbiesData ? getHobbiesData : ['']);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleAddField = () => {
        const newHobbies = [...hobbies, ""];
        setHobbies(newHobbies);
        setSuccess('')
        setError('')
    };

    const handleRemoveField = (index) => {
        const newHobbies = [...hobbies];
        newHobbies.splice(index, 1);
        setHobbies(newHobbies);
        setSuccess('')
        setError('')
    };

    const handleChange = (index, e) => {
        e.preventDefault()
        const updatedHobbies = [...hobbies];
        updatedHobbies[index] = e.target.value;
        setHobbies(updatedHobbies);
        setSuccess('')
        setError('')
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const newHobbies = [...hobbies];
        let isValid = newHobbies.every((each) => each !== "");

        const HobbiesTitles = newHobbies.map(item => item?.trim());
        const uniqueHobbiesTitles = new Set(HobbiesTitles);
        const hasDuplicateHobbiesTitle = HobbiesTitles.length !== uniqueHobbiesTitles.size;

        if (!isValid) {
            setSuccess('')
            setError('Fields are required!');
        } else if (hasDuplicateHobbiesTitle) {
            setError('Oops! It looks like some of the input values are the same!');
        } else {
            setError('');
            setSuccess('Thank you for providing your hobbie details.');
            setItem('hobbiesData', JSON.stringify(hobbies));
        }
    };

    const closePopUp = () => {
        setSuccess('')
        setError('')
    };

    return (
        <>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop='static'
            >
                <Modal.Header closeButton onClick={closePopUp}>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Hobbies
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {
                            hobbies.map((field, index) => (
                                <Row key={index} className="mb-3">

                                    <Col md={{ span: 5, offset: 3 }} className={hobbies.length === 1 ? 'col-12' : 'col-10'}>
                                        <Form.Group >
                                            <Form.Control
                                                type="text"
                                                name="hobbiesName"
                                                placeholder='Area of hobbies'
                                                value={field}
                                                onChange={(event) => handleChange(index, event)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    {
                                        hobbies.length > 1 && (
                                            <Col md={1} className='col-2'>
                                                <Button className='btn btn-danger' onClick={() => handleRemoveField(index)}><i className="fa fa-trash"></i></Button>
                                            </Col>
                                        )
                                    }

                                </Row>

                            ))
                        }

                        <Col md={{ span: 5, offset: 3 }} className='text-end mb-3'>
                            <Button className="text-end text-success btn finalize-btn" onClick={handleAddField} ><i className='fa fa-plus'></i> Add one more</Button>
                        </Col>

                        {
                            error ? <div className="alert alert-danger mt-3" role="alert">{error}</div> : ''
                        }

                        {
                            success ? <div className="alert alert-success mt-3" role="alert">{success}</div> : ''
                        }

                        <Modal.Footer>
                            <Button className='button-green' type="submit" onClick={handleSubmit}>Save changes</Button>
                        </Modal.Footer>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default HobbiesModal
